import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type Step = 'ADDRESS' | 'DELIVERY' | 'PAYMENT';
export const stepOrder: Step[] = ['ADDRESS', 'DELIVERY', 'PAYMENT'];

export interface CheckoutStepperState {
  currentStep: Step;
  completedSteps: Step[];
}

const initialState: CheckoutStepperState = {
  currentStep: 'ADDRESS',
  completedSteps: [],
};

const checkoutStepperSlice = createSlice({
  name: 'checkoutStepper',
  initialState,
  reducers: {
    goToStep: (state, action: PayloadAction<Step>) => {
      const newStep = action.payload;
      state.currentStep = newStep;

      const targetIndex = stepOrder.indexOf(newStep);

      state.completedSteps = state.completedSteps.filter(
        (step) => stepOrder.indexOf(step) <= targetIndex
      );
    },

    markStepCompleted: (state, action: PayloadAction<Step>) => {
      if (!state.completedSteps.includes(action.payload)) {
        state.completedSteps.push(action.payload);
      }
    },

    resetSteps: () => initialState,
  },
});

export const { goToStep, markStepCompleted, resetSteps } = checkoutStepperSlice.actions;
export default checkoutStepperSlice.reducer;
